/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useLangContext, useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useDismissMessageMutation, useGetSystemMessagesQuery } from '../../services/api';
import { useEnrolmentContext } from '../../lib/context';
import CalloutComponent from './CalloutComponent';
import NotificationComponent from './NotificationComponent';
import { getFilterPayload } from '../../lib/helpers';

interface ISystemMessagesComponentProps {
  systemId: number;
}

const SystemMessagesComponent: FC<ISystemMessagesComponentProps> = ({ systemId }) => {
  const lang = useLangContext();
  const user = useUserContext();
  const enrolments = useEnrolmentContext();
  // eslint-disable-next-line max-len
  const educations = enrolments?.educations.filter((enrolment) => enrolment.active).map((enrolment) => enrolment.id);
  const faculties = enrolments?.faculties.map((enrolment) => enrolment.id);
  const campuses = enrolments?.campuses.map((enrolment) => enrolment.id);

  const filterPayload = getFilterPayload(educations, faculties, campuses);

  const { data: systemMessages } = useGetSystemMessagesQuery({
    systemId,
    auId: user?.auId || 0,
    lang,
    educations: filterPayload.educations.length === 0 ? [0] : filterPayload.educations, // for at få alle systembeskeder uden filtre
    faculties: filterPayload.faculties,
    campuses: filterPayload.campuses,
  });

  const [dismissMessage] = useDismissMessageMutation();

  const renderCallouts = (systemMessages || []).filter(
    (msg) => msg.callout,
  ).map((msg) => createPortal(
    <CalloutComponent key={msg.id} systemMessage={msg} />,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.querySelector('.page__post-header')!,
  ));

  const renderNotifications = (systemMessages || []).filter(
    (msg) => msg.notification,
  ).map((msg) => (
    <NotificationComponent
      key={msg.id}
      systemMessage={msg}
      onDismiss={(message) => {
        dismissMessage({
          id: message.id,
          auId: user?.auId || 0,
        });
      }}
    />
  ));

  return (
    <>
      {renderCallouts}
      {
        (systemMessages || []).filter((msg) => msg.notification).length > 0 && (
          <div className="page__content__block">
            {renderNotifications}
          </div>
        )
      }
    </>
  );
};

SystemMessagesComponent.displayName = 'SystemMessagesComponent';
export default SystemMessagesComponent;
